module.exports = __webpack_public_path__ + "static/media/ali_partovi.791e620c.jpg";